<template>
  <div class="header">
    <div class="left-section">
      <!-- show hamburger only on mobile -->
      <hamburger v-if="device === 'mobile'" :toggleClick="toggleSideBar" :isActive="sidebar.opened" />

      <div class="logo">
        <span>{{ companyName }}</span>
      </div>
    </div>

    <div class="right-section">
      <!-- ✅ User Info (Name + Role) -->
      <div class="user-info">
        <span class="user-name">{{ userName }}</span>
        <!-- <span class="role-name">{{ roleName }}</span> -->
      </div>

      <el-button type="primary" size="mini" @click="logout">LogOut</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'

export default {
  name: "NavbarComponent",
  components: { Hamburger },
  computed: {
    ...mapGetters(['sidebar', 'device']),
    companyName() {
      return this.$store.getters.companyName || ''
    },
    userName() {
      return this.$store.getters.name || 'User'
    },
    roleName() {
      return this.$store.getters.role || 'Role'
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  height: 60px;
  background-color: #fff;
  color: #333;
  border-bottom: 1px solid #e5e5e5;
}

.left-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo span {
  font-size: 20px;
  font-weight: bold;
  color: #f30505;
}

.right-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* ✅ User info stacked vertically */
.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
}

.user-name {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.role-name {
  font-size: 12px;
  color: #777;
}

.icons {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logout {
  width: 20px;
  height: 20px;
  fill: #333;
  transition: 0.2s;
}

.logout:hover {
  fill: #f30505;
}

/* Only show hamburger on mobile */
@media (max-width: 1023px) {
  .hamburger-container {
    display: block;
  }
}
</style>
